import React,{useState} from "react";
import{removeItem} from './CartHelpers';

export default function CartItem({ product, value }) {
const [count,setCount] =useState(product.count);
const [total,setTotal] = useState(product.price)
const decrement = proId =>{
    let cart =[];
    let selectProduct;
    if(typeof window!=='undefined')
    {
        if(localStorage.getItem('cart'))
        {
            cart = JSON.parse(localStorage.getItem('cart'));
        }
        
        selectProduct = cart.find(pro=>pro._id===proId);
        const index =cart.indexOf(selectProduct);
        selectProduct.count -=1;
        if(selectProduct.count===0)
        {
          cart.splice(index,1);
        }
    }
    localStorage.setItem('cart',JSON.stringify(cart))
    setCount(selectProduct.count);
    setTotal(selectProduct.count*selectProduct.price);
};
const increment = proId =>{
    let cart =[];
    let selectProduct;
    if(typeof window!=='undefined')
    {
        if(localStorage.getItem('cart'))
        {
            cart = JSON.parse(localStorage.getItem('cart'));
        }
        
        selectProduct = cart.find(pro=>pro._id===proId);
        selectProduct.count +=1;
    }
    localStorage.setItem('cart',JSON.stringify(cart))
    setCount(selectProduct.count);
    setTotal(selectProduct.count*selectProduct.price);
}
  return (
    <div className="row my-1 text-capitalize text-center">
      <div className="col-10 mx-auto col-lg-2">
        <img
          src={`https://nhathuocvantien.herokuapp.com/api/product/photo/${product._id}`}
          style={{ widht: "5rem", height: "5rem" }}
          className="img-fluid"
          alt="product"
        />
      </div>
      <div className="col-10 mx-auto col-lg-2">
        <span className="d-lg-none">SẢN PHẨM:</span>
        {product.name}
      </div>
      <div className="col-10 mx-auto col-lg-2">
        <span className="d-lg-none">GIÁ :</span>
        {product.price+",000"}<sup>đ</sup>
      </div>
      <div className="col-10 mx-auto col-lg-2 my-2 my-lg-0">
        <div className="d-flex justify-content-center">
            <div class="input-group">
             
                <span className="btn btn-primary mx-1"
                  onClick={() => decrement(product._id)}> -
                </span>
            
              <input type="text" class="form-control" value={count}/>
              
                <span className="btn btn-primary mx-1"
                  onClick={() => increment(product._id)}> +
                </span>
              
            </div>
          </div>
      </div>
      <div className="col-10 mx-auto col-lg-2">
        <div className="cart-icon" onClick={() => removeItem(product._id)}>
          <i className="fas fa-trash" />
        </div>
      </div>
      <div className="col-10 mx-auto col-lg-2">
        <strong>{total+",000"}<sup>đ</sup></strong>
      </div>
    </div>
  );
}